import { TemplateRef, Type } from '@angular/core';

import { CellConfig, IIdentity, Parameter } from '.';

export interface CellEditConfig<T extends IIdentity> {
  type: TemplateRef<any> | Type<unknown>;
  config?: CellConfig<T>;
  parameters?: Parameter;
  /**
   * @description let the user decide when the cell should end it's edit mode
   * this will prevent the default end edit behavior and delegate responsibility to someone else
   * > eg. select lists with search functionality
   */
  delegateEndEdit?: boolean;

  /**
   * @description let the user decide when the cell should enter edit mode
   * this will prevent the default start edit behavior and delegate responsibility to someone else
   * > eg. actions menu
   */
  delegateStartEdit?: boolean;

  /**
   * @description when mode is set to dialog, the grid will open a dialog with the given component
   * > defaults to `inline`
   */
  mode?: 'inline' | 'dialog';

  /**
   * @description disable cell editing based on the given condition/function
   */
  allowEditing?: boolean | ((data: T) => boolean);
}
